import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textMObj, heading5Obj } = typographyStyles;
const neutral500 = colors.ui.neutral[500];
const neutral600 = colors.ui.neutral[600];
const neutral700 = colors.ui.neutral[700];

export const writePromptContainerCss = {
  ...textMObj,
  padding: "24px",
  color: neutral700,
  overflowY: "auto",
};

export const headingCss = {
  ...textMObj,
  color: neutral500,
  fontWeight: "normal",
  margin: 0,
};

export const promptHeaderWrapperCss = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "24px",
  marginBottom: "8px",
};

export const promptHeadingCss = {
  ...heading5Obj,
  color: neutral600,
  fontWeight: 700,
};
